export const isRealWorkspace = (workspaceId: string | null) => {
  return !!workspaceId;
};
